import React from 'react';
import BaseCard from '../../components/misc/BaseCard.jsx';
import MeetingContext from '../../components/misc/MeetingContext.jsx';
import MeetingNotes from '../../components/misc/MeetingNotes.jsx';
import ParticipantsCarousel from '../../components/misc/ParticipantsCarousel.jsx';

const BeforeMeeting = ({ calendarMeeting, fieldsParticipants, control, clearErrors }) => {
    return (
        <div className='max-w-3xl w-full mx-auto px-4 p-6'>
            {fieldsParticipants.length > 0 && (
                <>
                    <div className='text-xl font-bold text-theme1-title2 mb-4 px-8'>Meeting Attendees</div>

                    <ParticipantsCarousel
                        calendarMeetingId={calendarMeeting?.id}
                        items={fieldsParticipants}
                        className='mb-6'
                        edit
                        control={control}
                        clearErrors={clearErrors}
                    />
                </>
            )}

            <div className='text-xl font-bold text-theme1-title2 mb-4 px-8'>Meeting Objectives</div>

            <BaseCard className='m-0 mb-10 p-4 bg-theme1-white'>
                <MeetingNotes
                    calendarMeetingId={calendarMeeting?.id}
                    calendarMeetingUserNotes={calendarMeeting?.objectives}
                    calendarMeetingAINotes={calendarMeeting?.suggested_objectives}
                    nothingFound='No objectives found'
                    editButtonText='Edit Objectives'
                    highlightText='AI-Speculated Objectives'
                    notesType='objectives'
                />
            </BaseCard>

            <div className='text-xl font-bold text-theme1-title2 mb-4 px-8'>Meeting Obstacles</div>

            <BaseCard className='m-0 mb-10 p-4 bg-theme1-white'>
                <MeetingNotes
                    calendarMeetingId={calendarMeeting?.id}
                    calendarMeetingUserNotes={calendarMeeting?.obstacles}
                    calendarMeetingAINotes={calendarMeeting?.suggested_obstacles}
                    nothingFound='No obstacles found'
                    editButtonText='Edit Obstacles'
                    highlightText='AI-Speculated Obstacles'
                    notesType='obstacles'
                />
            </BaseCard>

            <div className='text-xl font-bold text-theme1-title2 mb-4 px-8'>Meeting Context</div>

            <BaseCard className='m-0 p-4 bg-theme1-white'>
                <MeetingContext
                    calendarMeetingId={calendarMeeting?.id}
                    calendarMeetingUserContext={calendarMeeting?.context}
                    calendarMeetingAIContext={calendarMeeting?.suggested_context}
                    highlightText='AI-Speculated Context'
                />
            </BaseCard>
        </div>
    );
};

export default BeforeMeeting;
